module.exports = __webpack_public_path__ + "img/logo-bkg.08eab613.svg";